import React, { useEffect, useState } from "react";
import Bookingdetails1 from "./Bookingsdetails1";
import toast from "react-hot-toast";

const Cancelbooking = ({
  summaryDetails,
  vehicleDetails,
  paymentDetailsData,
  getBookingDetail,
  selectedRow,
  cities,
  bookingCalleationPloicies,
  bookingCancellationDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const paymentCollectionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.paymentCollectionType;
  delete paymentCollectionType?.inverted;
  const [cancellationpolicy, setCacellationpolicy] = useState([]);
  const [requestedBy, setRequestedBy] = useState("");
  const [reason, setReason] = useState("");
  const [selectedTxnId, setSelectedTxnId] = useState(null);
  const profile = JSON.parse(localStorage.getItem("profile"));

  const reasonforCancellation = [
    "License verification failed",
    "ID verification failed",
    "Address proof verification failed",
    "Car not available",
    "User requested cancellation",
    "No driver available to deliver the car",
    "Unsupported delivery zone",
    "Others",
  ];

  const getCancellationPolicy = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cancellationpolicies`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        const rows = data?.entities?.rows || [];
        const bookingTypes = JSON.parse(
          localStorage.getItem("catalogValues"),
        )?.bookingTypes;
        const bookingTypeName = bookingTypes?.[summaryDetails?.bookingType];
        const isSubscriptionBooking = [
          summaryDetails?.bookingType,
          summaryDetails?.bookingTypeName,
          bookingTypeName,
          summaryDetails?.packageSelectedKey,
        ].some((value) =>
          String(value || "").toLowerCase().includes("subscription"),
        ) || [
          "dailyRateWeekly",
          "dailyRateFortnightly",
          "dailyRateMonthly",
        ].includes(summaryDetails?.packageSelectedKey);
        const bookingTypeFilter = isSubscriptionBooking
          ? "subscription"
          : "daily_rental";
        const filteredRows = rows.filter(
          (row) =>
            String(row?.forBookingType || "").toLowerCase() ===
            bookingTypeFilter,
        );
        
        if (requestedBy === "Admin") {
          setCacellationpolicy(filteredRows);
        } else {
          setCacellationpolicy(
            filteredRows.filter(
              (row) =>
                String(row?.name || "").trim().toLowerCase() !== "full refund",
            ),
          );
        }
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Cancellation policy:", error);
    }
  };

  useEffect(() => {
    if (bookingCancellationDetails) {
      getPolicyDetails(bookingCancellationDetails[0]?.policyId);
    }
  }, []);

  useEffect(() => {
    if (requestedBy) {
      getCancellationPolicy();
    }
  }, [requestedBy]);

  const [cancellationResponse, setCancellationResponse] = useState(null);

  const handleSelectCancellation = async (policyDetails) => {
    setSelectedTxnId(policyDetails?.id);
    try {
      const response = await fetch(
        `${apiUrl}/api/cancelledbookings/calculatecharges`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            policyDetails: {
              id: policyDetails?.id,
              tenantId: policyDetails?.tenantId,
              name: policyDetails?.name,
              timeBuffer: policyDetails?.timeBuffer,
              deductionPercentage: policyDetails?.deductionPercentage,
              onBillValueName: policyDetails?.onBillValueName,
              createdAt: policyDetails?.createdAt,
              updatedAt: policyDetails?.updatedAt,
              createdBy: policyDetails?.updatedBy,
              updatedBy: policyDetails?.createdBy,
            },
            bookingInfo: {
              costToCustomer: summaryDetails?.costToCustomer,
              weekdayRent: summaryDetails?.weekdayRent,
              weekendRent: summaryDetails?.weekendRent,
              bookingHrs: summaryDetails?.bookingHrs,
              deliveryCharges: summaryDetails?.deliveryCharges,
              pickupCharges: summaryDetails?.pickupCharges,
              taxAmount: summaryDetails?.taxAmount,
              discountAmount: summaryDetails?.discountAmount,
              discountPercentage: summaryDetails?.discountPercentage,
              securityDeposit: summaryDetails?.securityDeposit,
            },
          }),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setCancellationResponse(data?.entities);
        bookingCalleationPloicies(summaryDetails?.id);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Cancellation policy:", error);
    }
  };

  const handleCancelBooking = async () => {
    if (!reason) {
      return toast.error("Select reason to cancel", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: 50,
        },
      });
    }
    const refundable = cancellationResponse?.transactions?.find(
      (item) => item?.lineItem === "Refundable Amount",
    );

    toast.loading("Processing... Please wait", {
      id: "cancel", // same ID to update later
      position: "bottom-center",
    });

    try {
      const response = await fetch(`${apiUrl}/api/cancelledbookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          bookingStatus: fleetBookingStatus?.inverted?.cancelled,
          bookingId: summaryDetails?.id,
          bookingCode: summaryDetails?.bookingCode,
          policyId: cancellationResponse?.refundDataObject?.id,
          amountRefunded:
            cancellationResponse?.refundDataObject?.amountRefunded,
          totalRefundableAmount: Math.round(
            cancellationResponse?.refundDataObject?.totalRefundableAmount,
          ),
          amountToBeDeducted:
            cancellationResponse?.refundDataObject?.amountToBeDeducted,
          reason: reason,
          requestedBy: requestedBy,
          bookingObject: {
            id: summaryDetails?.id,
            bookingStatus: fleetBookingStatus?.inverted?.cancelled,
            refunableAmount: refundable?.amount,
          },
          lineItems: cancellationResponse?.transactions,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("cancel");
        toast.success("Booking Cancelled Successfully");
        getBookingDetail(paymentDetailsData?.inquiryCode, "inquiry");
        bookingCalleationPloicies(summaryDetails?.id);
        // getBookingDetail(selectedRow?.bookingCode, "booking");
        // getCancelRefunedDetails(summaryDetails?.id);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Cancellation policy:", error);
    }
  };

  const [policyId, setPolicyId] = useState(null);

  const getPolicyDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/cancellationpolicies/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPolicyId(data?.entityValue);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getCancelRefunedDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/cancelledbookings?bookingId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setCancellationResponse(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  // useEffect(() => {
  //   if (
  //     summaryDetails?.bookingStatus === fleetBookingStatus?.inverted?.cancelled
  //   ) {
  //     getCancelRefunedDetails(summaryDetails?.id);
  //   }
  // }, [summaryDetails]);

  return (
    <div className="md:p-6">
      <div className="flex items-start justify-between gap-6 mb-8">
        <div>
          <h2 className="text-2xl font-semibold text-[#2c3e50]">
            Booking Cancellation Process
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Review the booking details before proceeding.
          </p>
        </div>

        {(summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
          summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
          summaryDetails?.packageSelectedKey === "dailyRateMonthly") && (
          <div className="flex items-start gap-3 max-w-md px-4 py-3 rounded-xl bg-orange-50 border border-orange-200 shadow-sm">
            <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg bg-orange-100">
              <span className="text-orange-600 text-sm">📝</span>
            </div>

            <div>
              <p className="mt-1 text-xs leading-5 text-orange-700">
                Note: This booking is for a subscription here subscription
                policies will be available.
              </p>
            </div>
          </div>
        )}
      </div>
      {/* <Bookingdetails1
        paymentDetailsData={paymentDetailsData}
        vehicleDetails={vehicleDetails}
        summaryDetails={summaryDetails}
        cities={cities}
      /> */}

      {/* <div className="section mt-10">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-blue-500">
          Base Rent Details (Package: {summaryDetails?.packageDetails} Km)
        </h2>

        <div className="overflow-auto rounded-lg shadow bg-white">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="p-4">Weekday Rent</th>
                <th className="p-4">Weekend Rent</th>
                <th className="p-4">Discount Amount</th>
                <th className="p-4">Base Rent</th>
                <th className="p-4">Tax</th>
                <th className="p-4">Security Deposit</th>
                <th className="p-4">Pickup Charges</th>
                <th className="p-4">Delivery Charges</th>
                <th className="p-4 text-right">Rental</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b hover:bg-gray-50">
                <td className="p-4">
                  {summaryDetails?.weekdayRent +
                    "(" +
                    summaryDetails?.weekdayHrs +
                    " Hrs)" || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.weekendRent +
                    "(" +
                    summaryDetails?.weekendHrs +
                    " Hrs)" || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.discountAmount || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.weekdayRent + summaryDetails?.weekendRent ||
                    "N/A"}
                </td>
                <td className="p-4">{summaryDetails?.taxAmount || "N/A"}</td>
                <td className="p-4">
                  {summaryDetails?.securityDeposit || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.pickupCharges || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.deliveryCharges || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.weekdayRent +
                    summaryDetails?.weekendRent +
                    summaryDetails?.taxAmount +
                    summaryDetails?.securityDeposit +
                    summaryDetails?.pickupCharges +
                    summaryDetails?.deliveryCharges -
                    summaryDetails?.discountAmount || "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> */}

      {/* <div className="section mt-10">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-blue-500">
          Booking Costing Details
        </h2>

        <div className="overflow-auto rounded-lg shadow bg-white">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="p-4">Weekday Rent</th>
                <th className="p-4">Weekend Rent</th>
                <th className="p-4">Discount Amount</th>
                <th className="p-4">Base Rent</th>
                <th className="p-4">Tax</th>
                <th className="p-4">Security Deposit</th>
                <th className="p-4">Pickup Charges</th>
                <th className="p-4">Delivery Charges</th>
                <th className="p-4 text-right">Rental</th>
              </tr>
            </thead>
            <tbody>
              
            </tbody>
          </table>
        </div>
      </div> */}

      <label>
        Requested By{" "}
        <select
          onChange={(e) => {
            setRequestedBy(e.target.value);
          }}
          className="w-full h-12 mt-4 p-3 border border-gray-300 rounded-md"
          value={requestedBy || ""}
        >
          <option value="">Select</option>
          <option value="Admin">Admin</option>
          <option value="Customer">Customer</option>
        </select>
      </label>

      <div className="section mt-10">
        {String(summaryDetails?.bookingStatus) !==
          String(fleetBookingStatus?.inverted?.cancelled) && (
          <>
            {/* <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-blue-500">
              Cancellation Policy
            </h2> */}

            <div className="overflow-auto rounded-lg shadow bg-white">
              <table className="min-w-full text-sm text-left">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="p-4">Name</th>
                    <th className="p-4">Buffer Time</th>
                    <th className="p-4">Deduction %</th>
                    <th className="p-4">On Bill Value</th>
                    <th className="p-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {cancellationpolicy?.map((txn) => (
                    <>
                      {" "}
                      <tr key={txn?.id} className="border-b hover:bg-gray-50">
                        <td className="p-4">
                          {txn?.name}
                          <br />
                        </td>
                        <td className="p-4">{txn?.timeBuffer + " Hr"}</td>
                        <td className="p-4">
                          {txn?.deductionPercentage + " %"}
                        </td>
                        <td className="p-4">{txn?.onBillValueName}</td>
                        <td className="p-4">
                          <button
                            onClick={() => {
                              handleSelectCancellation(txn);
                            }}
                            className={`rounded-lg p-1 w-20 text-lg h-8 ${
                              selectedTxnId === txn.id
                                ? "bg-green-500 text-white"
                                : "bg-blue-500 text-white"
                            }`}
                          >
                            {selectedTxnId === txn.id ? "Selected" : "Select"}
                          </button>
                        </td>
                      </tr>
                    </>
                  ))}
                  {cancellationpolicy?.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center p-4 text-gray-500">
                        No transactions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}

        {cancellationResponse ? (
          <>
            <table className="min-w-full text-sm text-left shadow-lg border border-gray-100 mt-8">
              <thead className="">
                <tr>
                  <th className="p-3">Base Amount</th>
                  <th className="p-3">Amount To Be Deducted</th>
                  <th className="p-3">Amount to be Refunded</th>
                  <th className="p-3">
                    Refundable Amount (With Security Deposit)
                  </th>
                </tr>
              </thead>
              <tbody>
                {cancellationResponse ? (
                  <tr
                    // key={generatePaymentlinks?.id}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="p-4">
                      {"₹ " +
                        Number(
                          (cancellationResponse?.refundDataObject?.baseAmount).toFixed(
                            2,
                          ),
                        )}
                    </td>
                    <td className="p-4">
                      {"₹ " +
                        cancellationResponse?.refundDataObject
                          ?.amountToBeDeducted}
                    </td>
                    <td className="p-4">
                      {"₹ " +
                        Number(
                          (cancellationResponse?.refundDataObject?.amountRefunded).toFixed(
                            2,
                          ),
                        )}
                    </td>
                    <td className="p-4">
                      {"₹ " +
                        Number(
                          (cancellationResponse?.refundDataObject?.totalRefundableAmount).toFixed(
                            2,
                          ),
                        )}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center p-4 text-gray-500">
                      Cancellation Details.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <table className="min-w-full text-sm text-center shadow-lg border border-gray-100 mt-8">
              <thead className="">
                <tr>
                  <th className="p-4">Line Items</th>
                  <th className="p-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {cancellationResponse?.transactions?.length > 0 ? (
                  cancellationResponse.transactions.map((txn, index) => (
                    <tr key={index} className="border-b hover:bg-gray-50">
                      <td className="p-4">{txn?.lineItem}</td>
                      <td className="p-4">
                        {"₹ " +
                          (txn?.amount > 0
                            ? Math.round(txn?.amount)
                            : txn?.amount)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center p-4 text-gray-500">N/A</td>
                    <td className="text-center p-4 text-gray-500">N/A</td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        ) : (
          <div className="text-center p-4 text-gray-500">
            Please select a cancellation policy to view charges.
          </div>
        )}

        {cancellationResponse &&
          String(summaryDetails?.bookingStatus) !==
            String(fleetBookingStatus?.inverted?.cancelled) && (
            <>
              <div className="mt-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <label>Cancellation Reason</label>
                  <select
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className="w-92 h-12 p-3 border border-gray-300 rounded-md"
                  >
                    <option>Select</option>
                    {reasonforCancellation.map((item) => {
                      return <option>{item}</option>;
                    })}
                  </select>
                </div>
              </div>

              <div className="mt-4">
                <div class="flex justify-end items-center gap-12 h-full">
                  <div class="bg-gradient-to-b from-gray-800/40 to-transparent p-[4px] rounded-[16px]">
                    <button
                      onClick={handleCancelBooking}
                      class="group p-[4px] rounded-[12px] bg-gradient-to-b from-gray-700 to-gray-600 shadow-[0_2px_4px_rgba(0,0,0,0.7)] hover:shadow-[0_4px_8px_rgba(0,0,0,0.6)] active:shadow-[0_0px_1px_rgba(0,0,0,0.8)] active:scale-[0.995] transition-all duration-200"
                    >
                      <div class="bg-gradient-to-b from-gray-600 to-gray-700 rounded-[8px] px-3 py-2">
                        <div class="flex gap-2 items-center">
                          <span class="font-semibold text-white">
                            Proceed to cancel booking
                          </span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </>
            // ) : (
          )}

        {/* {String(summaryDetails?.bookingStatus) ===
          String(fleetBookingStatus?.inverted?.cancelled) && (
          <>
            <button
              onClick={initiateRefund}
              class="group p-[4px] mt-4 rounded-[12px] bg-gradient-to-b from-gray-700 to-gray-600 shadow-[0_2px_4px_rgba(0,0,0,0.7)] hover:shadow-[0_4px_8px_rgba(0,0,0,0.6)] active:shadow-[0_0px_1px_rgba(0,0,0,0.8)] active:scale-[0.995] transition-all duration-200"
            >
              <div class="bg-gradient-to-b from-gray-600 to-gray-700 rounded-[8px] px-3 py-2">
                <div class="flex gap-2 items-center">
                  <span class="font-semibold text-white">Initiate Refund</span>
                </div>
              </div>
            </button>
          </>
        )} */}
      </div>
    </div>
  );
};

export default Cancelbooking;
